<template>
  <div class="subscComplete">
    <svg class="subscComplete__logo" width="105" height="50" viewBox="0 0 105 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7974 11.3759H28.3315C28.9274 11.3759 29.415 11.2134 29.74 10.8342C30.065 10.5092 30.2817 10.0217 30.2817 9.42579V7.47562C30.2817 6.87974 30.1192 6.3922 29.74 6.06717C29.415 5.74215 28.9274 5.52546 28.3315 5.52546H18.7974C18.364 5.52546 18.1473 5.30878 18.1473 4.87541V1.95016C18.1473 1.35428 17.9848 0.866739 17.6056 0.541712C17.2806 0.216685 16.7931 0 16.1972 0H13.922C13.3261 0 12.8386 0.162514 12.5135 0.541712C12.1885 0.866739 11.9718 1.35428 11.9718 1.95016V18.1473C11.9718 18.5807 11.7551 18.7974 11.3218 18.7974H4.11701H1.89599H1.78765C1.24594 18.7974 0.812568 18.9599 0.487541 19.2849C0.270856 19.5016 0.108342 19.8267 0 20.2059V20.26V20.5309V20.6392V22.5894V35.2113C0 37.3781 0.379198 39.4366 1.1376 41.2243C1.89599 43.0661 2.92524 44.6371 4.27952 45.883C5.6338 47.1831 7.25894 48.1582 9.10076 48.9166C10.9426 49.6208 12.9469 50 15.1679 50C17.389 50 19.3933 49.6208 21.2351 48.9166C23.0769 48.2124 24.7021 47.1831 26.0563 45.883C27.4106 44.5829 28.4399 43.0119 29.1983 41.2243C29.9567 39.3824 30.3359 37.3781 30.3359 35.2113V22.6436V20.6934C30.3359 20.0975 30.1734 19.61 29.7942 19.2849C29.4691 18.9599 28.9816 18.7432 28.3857 18.7432H26.1105H18.7974C18.364 18.7432 18.1473 18.5265 18.1473 18.0932V12.026C18.1473 11.5926 18.364 11.3759 18.7974 11.3759ZM24.1604 24.5395V35.2654C24.1604 37.8657 23.402 39.9783 21.831 41.7118C20.26 43.4453 18.039 44.312 15.1138 44.312C12.1885 44.312 9.9675 43.4453 8.39653 41.7118C6.82557 39.9783 6.06717 37.8657 6.06717 35.2654V24.5395H24.1604ZM5.03894 11.9712H7.04327C7.58498 11.9712 8.01835 11.8087 8.34338 11.4837C8.6684 11.1587 8.83092 10.7253 8.83092 10.1836V6.71663C8.83092 6.17491 8.6684 5.74155 8.34338 5.41652C8.01835 5.09149 7.58498 4.92898 7.04327 4.92898H5.03894C4.49722 4.92898 4.06385 5.09149 3.73883 5.41652C3.4138 5.74155 3.25129 6.17491 3.25129 6.71663V10.1836C3.25129 10.7253 3.4138 11.1587 3.73883 11.4837C4.11803 11.8087 4.49722 11.9712 5.03894 11.9712ZM99.6218 5.58061H102.764C104.01 5.58061 104.443 6.17649 104.064 7.31409L91.2253 47.4008C91.0086 48.0508 90.7377 48.5384 90.3585 48.755C89.9793 49.0259 89.4918 49.1342 88.8959 49.1342H84.3997C83.8038 49.1342 83.3163 48.9717 82.9371 48.755C82.5579 48.5384 82.287 48.105 82.0704 47.4008L70.5319 11.3228H55.1473C54.7139 11.3228 54.4972 11.5394 54.4972 11.9728V47.1841C54.4972 47.78 54.3347 48.2675 54.0097 48.5925C53.6847 48.9176 53.1971 49.0801 52.6012 49.0801H50.3802C49.7843 49.0801 49.2968 48.9176 48.9718 48.5925C48.6467 48.2675 48.4842 47.78 48.4842 47.1841V11.9186C48.4842 11.4853 48.2675 11.2686 47.8342 11.2686H38.2459C37.65 11.2686 37.1624 11.1061 36.8374 10.781C36.5124 10.456 36.3499 9.96848 36.3499 9.37259V7.4766C36.3499 6.88072 36.5124 6.39318 36.8374 6.06815C37.1624 5.74312 37.65 5.58061 38.2459 5.58061H70.6944H73.8363H73.9988C74.5947 5.58061 75.0823 5.74312 75.4073 6.06815C75.6782 6.33901 75.8948 6.66403 76.0032 7.0974L86.079 41.0086C86.2415 41.4961 86.404 41.7128 86.7291 41.7128C87.0541 41.7128 87.2708 41.4961 87.3791 41.0086L97.455 7.0974C97.7258 6.06815 98.4842 5.58061 99.6218 5.58061Z" fill="url(#paint0_linear)"/>
      <defs>
      <linearGradient id="paint0_linear" x1="36.3499" y1="9.93597" x2="99.9247" y2="3.92829" gradientUnits="userSpaceOnUse">
      <stop offset="0.182292" stop-color="#FF7497"/>
      <stop offset="0.802083" stop-color="#CB8BFF"/>
      </linearGradient>
      </defs>
    </svg>
    <h1 class="subscComplete__title">ようこそ占いTVへ！</h1>
    <!--
    <p class="subscComplete__body">
      申込手続きが完了しました。<br>
      登録した情報は右上の
      <AccountIcon :width="17" :height="17" class="subscComplete__icon" />
      からアカウントメニューで確認・変更できます。ポイント管理や購入履歴確認、解約手続きもこちらから。</p>
    -->
    <p class="subscComplete__body">
      今日から2000メニュー以上の人気の占いが<br>
      24時間いつでもお楽しみいただけます。<br>
      まずは、占いに使うあなたの情報を登録していきましょう！</p>
    <BaseButton class="subscComplete__button" label="次へ" @clicked="next"/>

  </div>
</template>

<script>
import BaseButton from './common/BaseButton'
import AccountIcon from './common/icon/AccountIcon.vue'

export default {
  name: 'SubscComplete',
  components:{
    BaseButton,
    AccountIcon
  },
  methods: {
    next(){
      location.href = "/user/account/theme"
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";

.subscComplete{
  color: $col_base_black;
  padding: 48px 30px 40px;
  max-width: 580px;
  margin: auto;

  &__logo{
    width: 100%;
    text-align: center;
  }

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 4px 0 35px;
  }

  &__body{
    font-size: 13px;
    line-height: 21px;
  }

  &__head{
    font-size: 18px;
  }

  &__button{
    margin: 30px 0;
  }
  &__icon {
    vertical-align: -3px;
  }
  .baseButton__button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SubscComplete.vue